var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_shared-key.js
// module id = OUu6
// module chunks = 15